enum UserRole {
  GUEST = 'guest',
  USER  = 'user',
  STAFF = 'staff',
  ADMIN = 'admin',
}

export default UserRole;
